import { render, staticRenderFns } from "./Ela.vue?vue&type=template&id=f41d5316&scoped=true&"
import script from "./Ela.vue?vue&type=script&lang=js&"
export * from "./Ela.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f41d5316",
  null
  
)

export default component.exports